import { Box, Card, CardHeader, Skeleton } from '@mui/material';
import './GeofenceSkeleton.scss';
interface GeofenceSkeletonProps {
  isLoading: boolean;
}
const GeofenceSkeleton = ({ isLoading }: GeofenceSkeletonProps) => {
  return (
    <Box className='geofence-cardcontainer'>
      {[...Array(8)].map((value: any, index: number) => (
        <Card className='card-skeleton' key={index}>
          <CardHeader
            avatar={
              isLoading && (
                <Skeleton
                  className='geofence-circular-skeleton'
                  animation='wave'
                  variant='circular'
                />
              )
            }
            title={
              isLoading && (
                <Skeleton className='geofence-wave-skeleton' animation='wave' />
              )
            }
            subheader={
              isLoading && (
                <Skeleton className='geofence-subheader-skeleton' animation='wave' />
              )
            }
          />
        </Card>
      ))}
    </Box>
  );
};

export default GeofenceSkeleton;
